import React from 'react';
import { Link } from 'react-router-dom';
function FloatingActions() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4">
      <a
        href="https://wa.me/919487924282"
        target="_blank"
        rel="noopener noreferrer"
        className="w-16 h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center text-3xl shadow-2xl hover:scale-110 transition duration-300"
        title="WhatsApp Chat"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-8 h-8"
        >
          <path d="M20.52 3.48A11.86 11.86 0 0012.06 0C5.47 0 .12 5.35.12 11.94c0 2.1.55 4.15 1.6 5.96L0 24l6.28-1.65a11.9 11.9 0 005.78 1.48h.01c6.58 0 11.93-5.35 11.93-11.94 0-3.19-1.24-6.19-3.48-8.41zm-8.46 18.3h-.01a9.9 9.9 0 01-5.05-1.39l-.36-.21-3.73.98 1-3.64-.24-.37a9.88 9.88 0 01-1.52-5.22C2.15 6.48 6.54 2.1 12.06 2.1c2.64 0 5.13 1.03 7 2.9a9.83 9.83 0 012.9 6.99c0 5.52-4.39 9.9-9.9 9.9zm5.43-7.38c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.14-.14.3-.36.45-.54.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.08-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.69.25-1.29.17-1.42-.07-.12-.27-.2-.57-.35z" />
        </svg>
      </a>

      <a
        href="tel:+919487924282"
        className="w-16 h-16 rounded-full bg-blue-300 text-white flex items-center justify-center text-3xl shadow-2xl hover:scale-110 transition duration-300"
        title="Call Us"
      >
        📞
      </a>

    </div>
  );
}

export default FloatingActions;
